import { create } from 'zustand'

type Major = 'sw' | 'ee' | 'me' | ''

interface MajorState {
  major: Major
  setMajor: (major: Major) => void
}

const useMajorStore = create<MajorState>((set) => ({
  major: '', // 기본값
  setMajor: (major) => set({ major }),
}))

export default useMajorStore
